import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoSunweb = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 5c0 .55.45 1 1 1s1-.45 1-1V3c0-.55-.45-1-1-1s-1 .45-1 1zM16.44 7.45c-.57-.23-1.35-.41-2.34-.44l.02-.01c-1.63-.06-2.99.29-3.94 1.02-.91.7-1.42 1.7-1.46 2.89-.11 2.647 1.99 3.462 3.686 4.12l.059.024c1.295.504 2.405.936 2.365 2.016-.04.98-.86 1.51-2.25 1.46-1.18-.05-1.76-.3-2.19-.49a5 5 0 0 1-.226-.11c-.195-.099-.392-.198-.594-.22-.598-.07-.835.41-1.096.935q-.06.122-.124.245c-.22.4-.1.84.4 1.12.63.35 1.66.91 3.59.98 1.72.06 3.15-.3 4.14-1.06.94-.73 1.47-1.78 1.52-3.06.11-2.83-2.08-3.66-3.84-4.32l-.005-.002c-1.287-.489-2.315-.88-2.275-1.848.04-.86.74-1.31 2-1.26.939.04 1.457.255 1.865.424l.015.006q.09.04.177.083c.21.1.419.201.653.217.659.059.902-.452 1.195-1.068l.015-.032c.16-.34.14-.65-.16-.96-.19-.2-.76-.48-1.2-.66M8.81 6.99c-.32 0-.62-.15-.82-.43L6.84 4.92a.99.99 0 0 1 .25-1.39.99.99 0 0 1 1.39.25l1.15 1.64c.32.45.21 1.08-.25 1.39-.17.12-.38.18-.57.18M6.08 10.45a.998.998 0 0 0 1.28-.6 1 1 0 0 0-.6-1.28l-1.88-.68c-.52-.18-1.09.08-1.28.6s.08 1.09.6 1.28z"
    />
  </svg>
);
export default SvgLogoSunweb;
